import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Caja } from '../../../models/caja';
import { Cliente } from '../../../models/cliente';
import { Venta } from '../../../models/venta';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { ClienteService } from '../../../services/cliente.service';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { SessionService } from '../../../services/session.service';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { TipoTarjetaService } from '../../../services/tipo-tarjeta.service';
import { VentaService } from '../../../services/venta.service';
import { ClienteModalComponent } from '../cliente-modal/cliente-modal.component';
import * as moment from 'moment';
import { Cobro } from '../../../models/cobro';
import { VentaDetalle } from '../../../models/venta_detalle';
import { PedidoService } from '../../../services/pedido.service';
import { SweetMessage } from '../../../config/sweet-message';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { ConfirmacionAnulacionModalComponent } from '../confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ReporteModalComponent } from '../reporte-modal/reporte-modal.component';
import { Validation } from '../../../config/validation';
import { ParametroService } from '../../../services/parametro.service';
import { UtilsService } from '../../../services/utils.service';
import { Pedido } from '../../../models/pedido';
import { PedidoDetalle } from '../../../models/pedido_detalle';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import { Transferencia } from '../../../models/transferencia';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';

@Component({
  selector: 'app-facturar-pedido-modal',
  templateUrl: './facturar-pedido-modal.component.html',
  styleUrls: ['./facturar-pedido-modal.component.css'],
  providers: [
    ClienteService,
    SessionService,
    FormaPagoService,
    TipoTarjetaService,
    TipoComprobanteService,
    VentaService,
    CbtContadorService,
    PedidoService,
    ParametroService,
    ImpuestoPorcentajeService,
  ]
})
export class FacturarPedidoModalComponent implements OnInit {
  @Input() asignacion_id: string;
  @Input() caja: Caja;
  @Input() mesa_id: string;
  @Input() pedido_id: string;
  @Output() cerrarModal = new EventEmitter();
  public loading: boolean;
  public bsModalRefCliente: BsModalRef;
  public consumidorFinal: Cliente;
  public correos: Array<any>;
  public Mod_FactElec: string;
  public venta: Venta;
  public IVA: number;
  public sucursal_establecimiento: string;
  public cobro: Cobro;
  public cambio: number;
  public detallesVenta: Array<VentaDetalle>;
  public pedido_detalles: Array<any>;
  public valor_pago: string;
  public msgSweet: SweetMessage;
  public forma_pago_id: string;
  public bsModalRefAlert: BsModalRef;
  public listVentaIdPrinted: string;
  public debito_credito: string;
  public bsModalRefPrint: BsModalRef;
  public tipo_tarjeta_id: string;
  public vl: Validation;
  public indexCuenta: number;
  public listCuentas: Array<Venta>;
  public pedido: Pedido;
  public calculo_decimales: number;
  public numero_decimales: number;
  public total_pago: number;
  public fecha_emision;
  public Mod_Cartera: string;
  @ViewChild(DatosPagosComponent) datosPago: DatosPagosComponent;
  public isPrinted: boolean;

  constructor(
    private clienteService: ClienteService,
    private modalService: BsModalService,
    public ss: SessionService,
    private formaPagoService: FormaPagoService,
    private tipoTarjetaService: TipoTarjetaService,
    private tipoComprobanteService: TipoComprobanteService,
    private ventaService: VentaService,
    private cbtContadorService: CbtContadorService,
    private pedidoService: PedidoService,
    public bsModalRef: BsModalRef,
    public parametroService: ParametroService,
    public utils: UtilsService,
    public impuestoPorcentajeService: ImpuestoPorcentajeService,
  ) {
    this.loading = false;
    this.bsModalRefCliente = new BsModalRef();
    this.correos = [];
    this.Mod_FactElec = this.ss.getData("mod_felectronica");
    this.venta = new Venta();
    this.venta.tipocbt_select = "FACT";
    this.IVA = 0;
    this.sucursal_establecimiento = this.ss.getData('sucursal_establecimiento');
    this.cobro = new Cobro();
    this.cambio = 0;
    this.pedido_detalles = [];
    this.valor_pago = "";
    this.msgSweet = new SweetMessage();
    this.forma_pago_id = "1";
    this.bsModalRefAlert = new BsModalRef();
    this.listVentaIdPrinted = "";
    this.debito_credito = "D";
    this.bsModalRefPrint = new BsModalRef();
    this.tipo_tarjeta_id = "";
    this.vl = new Validation();
    this.detallesVenta = [];
    this.indexCuenta = 0;
    this.listCuentas = [this.venta];
    this.pedido = new Pedido();
    this.consumidorFinal = new Cliente();
    this.calculo_decimales = 2;
    this.numero_decimales = Number(this.ss.getData('numero_decimales'));
    this.total_pago = 0;
    this.fecha_emision = moment(this.fecha_emision);
    this.Mod_Cartera = this.ss.getData("mod_cartera");
    this.isPrinted = false;
  }

  ngOnInit() {
    //let p1 = this.getIVA();
    let p1 = this.getClienteById();
    let p2 = this.getPedido();

    //TODO: Por revisar getDetalles
    //this.getDetalles();

    this.loading = true;
    Promise.all([p1,p2]).then(
      res => {
        this.setPedidoInit();
        this.loading = false
      },
      err => this.loading = false,
    );

    if (this.Mod_FactElec) {
      this.venta.tipo_comprobante_id = "4";
    } else {
      this.venta.tipo_comprobante_id = "1";
    }
  }

  getPedido(){
    return new Promise((resolve, reject) => {
      this.pedidoService.getById(this.pedido_id).subscribe(
        res => {
          this.pedido = res.data;
          this.pedido.detalle.forEach(item => item.cantidad_op = item.cantidad);

          this.getIVA(this.pedido.impuesto_iva_id).then(
            res => resolve(),
            err => reject(err),
          );
        },
        err => {
          this.pedido = new Pedido();
          reject();
        }
      );
    });
  }

  /*getDetalles() {
    if (this.mesa_id != "") {
      let qs = "?mesa_id=" + this.mesa_id;
      this.pedidoService.getDetalles(qs).subscribe(
        res => {
          this.pedido_detalles = res.data;
          this.addDetalle();
        },
        err => {
          this.pedido_detalles = [];
        }
      );
    } else if (this.pedido_id != "") {
      let qs = "?mesa_id=0&pedido_id=" + this.pedido_id;
      this.pedidoService.getDetalles(qs).subscribe(
        res => {
          this.pedido_detalles = res.data;
          this.addDetalle();
        },
        err => {
          this.pedido_detalles = [];
        }
      );
    }
  }*/

  /*getIVA() {
    return new Promise((resolve, reject) => {
      this.parametroService.getById(1).subscribe(
        res => {
          this.IVA = parseFloat(res.valor) / 100;
          resolve();
        },
        err => {
          this.IVA = 0;
          reject(err);
        }
      );
    });
  }*/

  getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
          this.IVA = parseFloat(res.porcentaje) / 100;
					resolve();
				},
				err => {
          this.IVA = 0;
					reject(err);
				}
			);
		});
	}

  onSearchCliente(event) {
    if (event.keyCode === 13) {
      if (this.venta.cliente.dni.toString().trim().length == 0) {
        this.venta.cliente = new Cliente();
        return;
      } else {
        this.clienteService.getByDni(this.venta.cliente.dni).subscribe(
          res => {
            this.loading = false;
            if (res.length > 0) {
              this.venta.cliente = res[0];
            } else {
              this.venta.cliente = new Cliente();
              this.openDialogCliente();
            }
          },
          err => {
            this.loading = false;
            this.openDialogCliente();
          }
        );
      }
    }
  }

  onChangeTipoDoc() {
    if (this.venta.tipocbt_select == "FACT") {
      if (this.Mod_FactElec) {
        this.venta.tipo_comprobante_id = "4";
      } else {
        this.venta.tipo_comprobante_id = "1";
      }
    } else {
      this.venta.tipo_comprobante_id = "2";
    }

    this.listVentaIdPrinted = "";
    this.calcularTotalVenta();
    [this.total_pago, this.cambio] = this.calcularTotalPago(this.venta);
  }

  getClienteById() {
    return new Promise((resolve, reject) => {
      let cliente_cfinal_id = "1";
      this.clienteService.getById(cliente_cfinal_id, "?embed=tipoidentificacion").subscribe(
        res => {
          this.consumidorFinal = res.data;
          this.venta.cliente = this.consumidorFinal;
          this.correos = this.venta.cliente.correo.split(',');
          resolve();
        },
        err => {
          this.venta.cliente = new Cliente();
          reject(err);
        }
      );
    });
  }

  openDialogCliente() {
    const initialState = { qs: "&embed=tipoidentificacion" };
    this.bsModalRefCliente = this.modalService.show(ClienteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

    this.bsModalRefCliente.content.sendCliente.take(1).subscribe((cliente) => {
      this.venta.cliente = cliente;
      this.correos = this.venta.cliente.correo.split(',');
    });
  }

  setValueEntityVenta() {
    this.listCuentas.forEach((venta: Venta) => {
      venta.caja_id = this.caja.id;
      venta.asignacion_caja_id = this.asignacion_id.toString();

      venta.serie = this.sucursal_establecimiento;
      venta.punto_emision = this.caja.punto_emision;

      venta.numero_documento = venta.serie + "-" + venta.punto_emision + "-" + venta.secuencial;

      venta.cliente_id = venta.cliente.id;
      venta.fecha_emision = moment().format("YYYY-MM-DD")
      venta.usuario_id = this.ss.getData('usuario_id');
      venta.empresa_id = this.ss.getData('empresa_id');
      venta.sucursal_id = this.ss.getData('sucursal_id');

      let recibido = 0;

      if( venta.cobros.length ){
        venta.cobros[0].detalle.forEach(detalle => {
          recibido = recibido + parseFloat(detalle.valor.toString());
        });
  
        venta.cobros[0].recibido = recibido;
        venta.cobros[0].cambio = this.cambio;
        venta.cobros[0].saldo = this.venta.total;
        venta.cobros[0].fecha_cobro = moment().format("YYYY-MM-DD");
      }

      venta.detalle.forEach(detalle => {
        if (parseInt(venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4) {
          if (!detalle.graba_iva) {
            detalle.iva = 0;
          } else {
            detalle.iva = detalle.subtotal * this.IVA;
          }
        } else {
          detalle.iva = 0;
        }
        detalle.total = detalle.subtotal + detalle.iva;
      });

      venta.mesa_id = this.mesa_id;
      venta.pedido_id = this.pedido_id;

      venta.json_string = this.setVentaElectronica(venta);
    });
  }

  addDetalle() {
    this.pedido_detalles.forEach(detalle => {
      if (detalle.status === 'I') {
        let venta_detalle = new VentaDetalle();
        venta_detalle.cantidad = detalle.cantidad
        // venta_detalle.es_servicio = detalle.es_servicio;
        venta_detalle.tipo_producto_id = detalle.tipo_producto_id;
        venta_detalle.descripcion = detalle.descripcion;
        venta_detalle.producto = detalle.nombre;
        venta_detalle.codigo = detalle.codigo;
        venta_detalle.unidad = detalle.unidad;
        venta_detalle.producto_id = detalle.producto_id;
        venta_detalle.graba_iva = detalle.graba_iva;
        venta_detalle.precio_unitario = parseFloat(detalle.precio_unitario);
        venta_detalle.subtotal = venta_detalle.cantidad * venta_detalle.precio_unitario;
        venta_detalle.usuario_id = this.ss.getData('usuario_id');
        venta_detalle.empresa_id = this.ss.getData('empresa_id');
        venta_detalle.sucursal_id = this.ss.getData('sucursal_id');

        this.detallesVenta.unshift(venta_detalle);
        this.calcularTotalVenta();
      }
    });
  }

  calcularTotalVenta() {
    this.venta = this.ventaService.calcularTotales(this.venta, this.venta.tipo_comprobante_id, this.venta.detalle, this.IVA, 0);
    this.venta.total = this.utils.redondear(this.venta.total,2);
  }

  calcularTotalPago(venta: Venta) {
    let total_pago = 0;
    let cambio = 0;
    if( venta.cobros.length ){
      venta.cobros[0].detalle.forEach(detalle => {
        total_pago = parseFloat(total_pago.toString()) + parseFloat(detalle.valor.toString());
      });
    }
    cambio = (total_pago > venta.total ? (total_pago - venta.total) : 0);
    cambio = Math.round(cambio * 100) / 100;

    return [ total_pago, cambio ];
  }

  onChangeValorPago(total){   
    this.total_pago = total;

    //CALCULAR CAMBIO
    let saldo = this.venta.total - this.venta.abonado;

    if( this.venta.retencion ){
        saldo = saldo - this.venta.retencion.total;
    }

    this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
    //this.cambio = Math.round( this.cambio * 100) / 100;
    this.cambio = this.utils.redondear(this.cambio, this.calculo_decimales);

    this.setValueCobro();
  }

  onSubmitVenta() {
    let preg = "¿Está seguro de confirmar la venta?";
    const initialState = { Pregunta: preg, Respuesta: false };
    this.bsModalRefAlert = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, { initialState }));

    this.bsModalRefAlert.content.action.take(1).subscribe((Respuesta) => {
      if (Respuesta == true) {
        this.setValueEntityVenta();

        if(!this.isValidGuardar()){
          return false;
        }

        this.loading = true;

        this.pedidoService.facturarPedidos(this.listCuentas).subscribe(
          res => {
            this.isPrinted = true;
            this.loading = false;
            this.listVentaIdPrinted = "";

            let arrayVentaId = [];

            res.forEach(venta => arrayVentaId.push(venta.id));
            this.listVentaIdPrinted = arrayVentaId.join(",");

            this.onPrintVenta();

            if (this.Mod_FactElec) this.cbtContadorService.actualizarContador();
            this.cerrarModal.emit(true);
          },
          err => {
            this.isPrinted = false;
            this.loading = false;
            this.msgSweet.showMessage('error-message', err);
          }
        );
      }
    });
  }

  onPrintVenta() {
    if (this.Mod_FactElec) {
      if (this.venta.tipo_comprobante_id == "4") { //FACTURA ELECTRONICA
        this.printCbtFactElect();
      } else {
        this.printCbtNotaVenta();
      }
    } else {
      if (this.venta.tipo_comprobante_id == "1") { //FACTURA FISICA
        this.printFacturaFisica();
      } else {
        this.printCbtNotaVenta();
      }
    }
  }

  printCbtNotaVenta() {
    const initialState = { route: "cbt/notaventa/" + this.listVentaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token') };
    this.bsModalRefPrint = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: '', initialState }));
  }
  
  printCbtFactElect() {
    const initialState = { route: "cbt/factelect/" + this.listVentaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token') };
    this.bsModalRefPrint = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: '', initialState }));
  }

  printFacturaFisica() {
    this.printCbtFactElect();
  }

  onClosePagoModal() {
    this.bsModalRef.hide();
  }

  setVentaElectronica(venta: Venta) {
    let ventaElectronica = {};
    ventaElectronica['datos'] = {};
    ventaElectronica['datos']['infoTributaria'] = {};
    ventaElectronica['datos']['infoTributaria']['ambiente'] = "";
    ventaElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
    ventaElectronica['datos']['infoTributaria']['razonSocial'] = "";
    ventaElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
    ventaElectronica['datos']['infoTributaria']['claveAcceso'] = "";
    ventaElectronica['datos']['infoTributaria']['codDoc'] = "01"; //Factura
    ventaElectronica['datos']['infoTributaria']['estab'] = venta.serie;
    ventaElectronica['datos']['infoTributaria']['ptoEmi'] = venta.punto_emision;
    ventaElectronica['datos']['infoTributaria']['secuencial'] = venta.secuencial.toString().padStart(9, "0");
    ventaElectronica['datos']['infoTributaria']['dirMatriz'] = ""; //this.ss.getData('emp_direccion');

    ventaElectronica['datos']['infoFactura'] = {};
    ventaElectronica['datos']['infoFactura']['fechaEmision'] = moment(venta.fecha_emision).format("DD/MM/YYYY");
    ventaElectronica['datos']['infoFactura']['dirEstablecimiento'] = this.ss.getData('sucursal_direccion');
    ventaElectronica['datos']['infoFactura']['tipoIdentificacionComprador'] = venta.cliente.tipoidentificacion.cod_dni;
    ventaElectronica['datos']['infoFactura']['razonSocialComprador'] = venta.cliente.razon_social.toString().replace("&", "Y");
    ventaElectronica['datos']['infoFactura']['identificacionComprador'] = venta.cliente.dni;

    let totalSinImpuestos = 0;
    venta.detalle.forEach(item => {
      totalSinImpuestos += Math.round(item.subtotal * 100) / 100;
    });

    ventaElectronica['datos']['infoFactura']['totalSinImpuestos'] = totalSinImpuestos;
    ventaElectronica['datos']['infoFactura']['totalDescuento'] = venta.desct_valor;

    ventaElectronica['datos']['infoFactura']['totalConImpuestos'] = [];
    if (venta.subtotal_iva0 > 0) {
      let totalConImpuestos = {};
      totalConImpuestos['codigo'] = 2;
      totalConImpuestos['codigoPorcentaje'] = 0;
      totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
      totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva0 * 100) / 100);
      totalConImpuestos['valor'] = "0.00";

      ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
    }

    if (venta.subtotal_iva12 > 0) {
      let totalConImpuestos = {};
      totalConImpuestos['codigo'] = 2;
      totalConImpuestos['codigoPorcentaje'] = 2;
      totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
      totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva12 * 100) / 100);
      totalConImpuestos['valor'] = (Math.round(venta.iva * 100) / 100);

      ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
    }

    ventaElectronica['datos']['infoFactura']['propina'] = "0.00";
    ventaElectronica['datos']['infoFactura']['importeTotal'] = (Math.round(venta.total * 100) / 100);
    ventaElectronica['datos']['infoFactura']['moneda'] = "DOLAR";

    ventaElectronica['datos']['infoFactura']['pagos'] = [];

    //if( this.venta.tipo == "CO" ){
    //01 => EFECTIVO
    let totalEfectivo = 0;
    this.cobro.detalle.forEach(detalle => {
      if (detalle.forma_pago_id == "1") { // EFECTIVO
        totalEfectivo += parseFloat(detalle.valor.toString());
      }
    });

    if (totalEfectivo > 0) {
      let pago = {};
      pago["formaPago"] = "01";
      pago["total"] = (Math.round((parseFloat(totalEfectivo.toString()) - parseFloat(this.cambio.toString())) * 100) / 100);
      pago["plazo"] = "0";
      pago["unidadTiempo"] = "DIAS";
      ventaElectronica['datos']['infoFactura']['pagos'].push(pago);
    }
    ventaElectronica['datos']['detalles'] = [];
    venta.detalle.forEach((item) => {
      let detalle = {};
      let detalle_item = item.detalle.toString().replace(/\n/g, ", ");

      detalle['codigoPrincipal'] = (item.codigo).replace(/\//g, '-');
      detalle['codigoAuxiliar'] = (item.codigo).replace(/\//g, '-');
      detalle['descripcion'] = (item.producto + (item.detalle.length > 0 ? " - " + detalle_item : "")).replace(/\//g, '-');
      detalle['cantidad'] = item.cantidad;
      detalle['precioUnitario'] = (Math.round(item.precio_unitario * 100) / 100);
      detalle['descuento'] = (Math.round(item.desc_valor * 100) / 100);
      detalle['precioTotalSinImpuesto'] = (Math.round(item.subtotal * 100) / 100);
      detalle['impuestos'] = [];
      let impuesto = {};
      impuesto['codigo'] = 2;
      impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0);
      impuesto['tarifa'] = (item.iva > 0 ? 12 : 0);
      impuesto['baseImponible'] = (Math.round(item.subtotal * 100) / 100);
      impuesto['valor'] = Math.round(item.iva * 100) / 100;
      detalle['impuestos'].push(impuesto);
      ventaElectronica['datos']['detalles'].push(detalle);
    });

    ventaElectronica['datos']['infoAdicional'] = [];
    let adicional = {};
    adicional['Email'] = this.correos.toString(); //this.cliente.correo;
    adicional['Direccion'] = venta.cliente.direccion.replace(/\//g, '-');

    let telefono = "0999999999";
    if (venta.cliente.telefono.toString().trim().length > 0) {
      telefono = venta.cliente.telefono.toString();
    }
    if (venta.cliente.celular.toString().trim().length > 0) {
      telefono = venta.cliente.celular.toString();
    }
    adicional['Telefono'] = telefono;

    ventaElectronica['datos']['infoAdicional'].push(adicional);

    return ventaElectronica;
  }

  removePago(i) {
    this.cobro.detalle.splice(i, 1);
    [this.total_pago, this.cambio] = this.calcularTotalPago(this.venta);
  }

  isValidGuardar() {
    for(let i = 0; i < this.listCuentas.length; i++){
      let total_pago = 0;

      let venta = this.listCuentas[i];
      [total_pago] = this.calcularTotalPago(venta);
      
      if (total_pago <= 0 || total_pago < venta.total) {
        this.msgSweet.showMessage('error-message', "El pago es menor al total (cuenta #" + ( i + 1 ) + ")");
        return false;
      }
      if (!venta.cliente.id) {
        this.msgSweet.showMessage('error-message', "Debe de seleccionar un cliente (cuenta #" + ( i + 1 ) + ")");
        return false;
      }
      if (this.Mod_FactElec) {
        if (venta.cliente.es_contribuyente) {
          if (venta.cliente.num_contribuyente.toString().trim().length === 0) {
            this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente (cuenta #" + ( i + 1 ) + ")");
            return false;
          }
        }
        if (venta.total >= 200 && venta.cliente.id == "1" && venta.tipo_comprobante_id == "4") {
          this.msgSweet.showMessage('error-message', "No puede realizar una venta cuyo monto supere los $200 a Consumidor Final (cuenta #" + ( i + 1 ) + ")");
          return false;
        }
      }
    }

    for(let i = 0; i < this.pedido.detalle.length; i++){
      let item = this.pedido.detalle[i];

      if( item.cantidad > 0 ){
        this.msgSweet.showMessage('error-message', "Hay items que falta incluir en la factura");
        return false;
      }
    }

    /*if (this.correos.length <= 0) {
      return false;
    }*/
    return true;
  }

  clickKeyboard(key) {
    if (key == "C") {
      this.valor_pago = this.valor_pago.toString().slice(0, -1)
    } else {
      this.valor_pago = this.valor_pago + key;
    }
  }

  addCuenta(){
    let venta = new Venta();
    //venta.asignacion_caja_id = this.asignacion_id;
    //venta.caja_id = this.caja.id;
    venta.tipocbt_select = "FACT";
    if (this.Mod_FactElec) {
      venta.tipo_comprobante_id = "4";
    } else {
      venta.tipo_comprobante_id = "1";
    }
    venta.cliente = {...this.consumidorFinal};
    //this.correos = venta.cliente.correo.split(',');
    this.listCuentas.push(venta);
  }

  quitarCuenta(i: number){
    if( this.listCuentas.length > 1 ){

      this.removeVentaItem(i);

      this.listCuentas.splice(i, 1);

      if( i <= this.indexCuenta ){
        if( i == 0 ){
          this.indexCuenta = 0;
        }else{
          this.indexCuenta--;
        }
      }

      this.venta = this.listCuentas[this.indexCuenta];
    }
  }

  seleccionarCuenta(i: number){
    this.indexCuenta = i;
    this.venta.cliente.correo = this.correos.join(',');
    this.venta = this.listCuentas[i];
    this.correos = this.venta.cliente.correo.split(',');

    this.datosPago.valorefectivo = 0;
    this.datosPago.cheques = [];
    this.datosPago.tarjetas = [];
    this.datosPago.transferencias = [];

    this.setCobros();
  }

  setCobros(){
    if( this.venta.cobros.length ){
      this.venta.cobros[0].detalle.forEach(cobro_detalle => {
        // EFECTIVO
        if( cobro_detalle.forma_pago_id == "1" ){
          this.datosPago.valorefectivo = cobro_detalle.valor;
        }
  
        // CHEQUE
        if( cobro_detalle.forma_pago_id == "2" ){
          let ch = new Cheque();
          ch.fecha = cobro_detalle.fecha_cheque;
          ch.cuenta = cobro_detalle.numero_cta;
          ch.numero = cobro_detalle.numero_cheque;
          ch.banco_id = cobro_detalle.banco_id;
          ch.banco = cobro_detalle.banco;
          ch.observacion = cobro_detalle.observacion;
          ch.valor = cobro_detalle.valor;

          this.datosPago.cheques.push(ch);
        }
  
        // TARJETA
        if( cobro_detalle.forma_pago_id == "3" ){
          let tr = new Tarjeta();
  
          tr.debito_credito = cobro_detalle.debito_credito;
          tr.observacion = cobro_detalle.observacion;
          tr.tipo_id = cobro_detalle.tipo_tarjeta_id;
          tr.tipo = cobro_detalle.tipotarjeta;
          tr.valor = cobro_detalle.valor;
          tr.plazo = cobro_detalle.plazo;
          tr.tiempo = cobro_detalle.tiempo;
          
          this.datosPago.tarjetas.push(tr);
        }
  
        // TRANSFERENCIA
        if( cobro_detalle.forma_pago_id == "6" ){
          let tr = new Transferencia();
          tr.fecha = cobro_detalle.fecha_transferencia;
          tr.cuenta = cobro_detalle.numero_cta;
          tr.numero = cobro_detalle.numero_comprobante;
          tr.banco_id = cobro_detalle.banco_id;
          tr.banco = cobro_detalle.banco;
          tr.observacion = cobro_detalle.observacion;
          tr.valor = cobro_detalle.valor;

          this.datosPago.transferencias.push(tr);
        }
      });
    }
    this.datosPago.setTotal();
    
  }

  addItem(detalle: PedidoDetalle){
    if( detalle.cantidad == 0 ){
      return;
    }

    let venta_detalle = null;
    let item_venta = this.venta.detalle.find(item => item.producto_id == detalle.producto_id);
    
    if( item_venta ){
      venta_detalle = item_venta;
      venta_detalle.cantidad++;
    }else{
      venta_detalle = new VentaDetalle();
      this.venta.detalle.push(venta_detalle);
      venta_detalle.cantidad = 1;
    }

    detalle.cantidad--;
    venta_detalle.precio_unitario = detalle.precio_unitario;
    venta_detalle.subtotal = this.utils.redondear((venta_detalle.cantidad * venta_detalle.precio_unitario), this.calculo_decimales);
    venta_detalle.detalle = detalle.detalle;
    let producto_nombre: any = detalle.producto.nombre;
    venta_detalle.producto = producto_nombre;
    venta_detalle.graba_iva = detalle.producto.graba_iva;
    
    if( parseInt(this.venta.tipo_comprobante_id.toString()) === 1 || parseInt(this.venta.tipo_comprobante_id.toString()) === 4 ){
      if( detalle.producto.graba_iva  == false ){
          venta_detalle.iva = 0;
          venta_detalle.porct_iva = 0;
      }else{
          venta_detalle.iva = venta_detalle.subtotal * this.IVA;
          venta_detalle.porct_iva = this.IVA;
      }
    }else{
        venta_detalle.iva = 0;
        venta_detalle.porct_iva = 0;
    }

    venta_detalle.total = venta_detalle.subtotal + venta_detalle.iva;
    venta_detalle.producto_id = detalle.producto.id;
    venta_detalle.usuario_id = this.ss.getData('usuario_id');
    venta_detalle.empresa_id = this.ss.getData('empresa_id');
    venta_detalle.sucursal_id = this.ss.getData('sucursal_id');

    //this.calcularFactura();

    this.calcularTotalVenta();
    [this.total_pago, this.cambio] = this.calcularTotalPago(this.venta);
  }

  onClickToRemoveItem(venta_detalle: VentaDetalle, i: number){
    this.removeItem(this.venta, venta_detalle, i);
  }

  removeItem(venta: Venta, venta_detalle: VentaDetalle, i: number){
    let item_pedido = this.pedido.detalle.find(pedido => {
      if( pedido.cantidad < pedido.cantidad_op ) {
        return pedido.producto_id == venta_detalle.producto_id;
      }
    });
    
    item_pedido.cantidad++;
    venta_detalle.cantidad--;

    if( venta_detalle.cantidad == 0 ) {
      venta.detalle.splice(i, 1);
    }else{
      venta_detalle.subtotal = this.utils.redondear((venta_detalle.cantidad * venta_detalle.precio_unitario), this.calculo_decimales);

      if( parseInt(venta.tipo_comprobante_id.toString()) === 1 || parseInt(venta.tipo_comprobante_id.toString()) === 4 ){
        if( venta_detalle.producto.graba_iva  == false ){
            venta_detalle.iva = 0;
            venta_detalle.porct_iva = 0;
        }else{
            venta_detalle.iva = venta_detalle.subtotal * this.IVA;
            venta_detalle.porct_iva = this.IVA;
        }
      }else{
          venta_detalle.iva = 0;
          venta_detalle.porct_iva = 0;
      }

      venta_detalle.total = venta_detalle.subtotal + venta_detalle.iva;
    }

    //this.calcularFactura();
    this.calcularTotalVenta();
    [this.total_pago, this.cambio] = this.calcularTotalPago(venta);
  }

  onChangeEfectivo(total){
    //this.calcularCuotasCredito();
    //this.valorefectivo = total;
    //console.log("total", total);
    
  }

  setValueCobro(){
    let cobro = new Cobro();
    cobro.fecha_cobro = moment(this.fecha_emision).format("YYYY-MM-DD");
    cobro.detalle = [];
    cobro.saldo = this.venta.total;

    if( this.Mod_Cartera ){
        cobro.recibido = this.total_pago;
        cobro.cambio = this.cambio;
    }else{
        cobro.recibido = this.venta.total;
        cobro.cambio = 0;
    }

    cobro.empresa_id = this.ss.getData("empresa_id");
    cobro.sucursal_id = this.ss.getData("sucursal_id");
    cobro.usuario_id = this.ss.getData("usuario_id");

    if( this.Mod_Cartera ){
      if( this.datosPago.valorefectivo > 0 ){
          let cobro_detalle = new CobroDetalle();
          cobro_detalle.valor = this.datosPago.valorefectivo;
          cobro_detalle.forma_pago_id = "1"; // EFECTIVO
          cobro_detalle.debito_credito = "D";
          cobro_detalle.empresa_id = this.ss.getData("empresa_id");
          cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
          cobro_detalle.usuario_id = this.ss.getData("usuario_id");
          cobro.detalle.push(cobro_detalle);
      }

      this.datosPago.cheques.forEach(ch => {
          let cobro_detalle = new CobroDetalle();

          cobro_detalle.fecha_cheque = ch.fecha;
          cobro_detalle.numero_cta = ch.cuenta;
          cobro_detalle.numero_cheque = ch.numero;
          cobro_detalle.banco_id = ch.banco_id;
          cobro_detalle.banco = ch.banco;
          cobro_detalle.observacion = ch.observacion;
          cobro_detalle.debito_credito = "D";
          cobro_detalle.valor = ch.valor;
          cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
          cobro_detalle.empresa_id = this.ss.getData("empresa_id");
          cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
          cobro_detalle.usuario_id = this.ss.getData("usuario_id");
          cobro.detalle.push(cobro_detalle);
      });

      this.datosPago.tarjetas.forEach(tr => {
          let cobro_detalle = new CobroDetalle();

          cobro_detalle.debito_credito = tr.debito_credito;
          cobro_detalle.observacion = tr.observacion;
          cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
          cobro_detalle.tipotarjeta = tr.tipo;
          cobro_detalle.valor = tr.valor;
          cobro_detalle.plazo = tr.plazo;
          cobro_detalle.tiempo = tr.tiempo;
          cobro_detalle.debito_credito = "D";
          cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
          cobro_detalle.empresa_id = this.ss.getData("empresa_id");
          cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
          cobro_detalle.usuario_id = this.ss.getData("usuario_id");
          cobro.detalle.push(cobro_detalle);
      });

      this.datosPago.transferencias.forEach(tr => {
          let cobro_detalle = new CobroDetalle();

          cobro_detalle.fecha_transferencia = tr.fecha;
          cobro_detalle.numero_cta = tr.cuenta;
          cobro_detalle.numero_comprobante = tr.numero;
          cobro_detalle.banco_id = tr.banco_id;
          cobro_detalle.banco = tr.banco;
          cobro_detalle.observacion = tr.observacion;

          cobro_detalle.valor = tr.valor;
          cobro_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
          cobro_detalle.empresa_id = this.ss.getData("empresa_id");
          cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
          cobro_detalle.usuario_id = this.ss.getData("usuario_id");
          cobro.detalle.push(cobro_detalle);
      });
    }else{
      let cobro_detalle = new CobroDetalle();
      cobro_detalle.valor = this.venta.total;
      cobro_detalle.forma_pago_id = "1"; // EFECTIVO
      cobro_detalle.debito_credito = "D";
      cobro_detalle.empresa_id = this.ss.getData("empresa_id");
      cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
      cobro_detalle.usuario_id = this.ss.getData("usuario_id");
      cobro.detalle.push(cobro_detalle);
    }

    this.venta.cobros = [cobro];
  }

  setPedidoInit(){
    this.pedido.detalle.forEach(item => {
      this.addItem(item);
    });
  }

  removeVentaItem(index: number){
    while(true){
      for(let i = 0; i < this.listCuentas[index].detalle.length; i++){
        let item = this.listCuentas[index].detalle[i];

        this.removeItem(this.listCuentas[index], item, i);
      }

      if( this.listCuentas[index].detalle.length == 0 ){
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/facturar-pedido-modal/facturar-pedido-modal.component.ts